module.exports = __webpack_public_path__ + "img/1@2x.b2e4e30d.png";